import type { LabsElementaryGraph } from "@/client/core/platform-types/labs.api";
import { el } from "@splice/elemaudio-core";

export const createTestToneGraph = (): LabsElementaryGraph => {
    return {
        nodes: [
            el.mul(0.1, el.sin(el.mul(2 * Math.PI, el.phasor(660)))),
            el.mul(0.1, el.sin(el.mul(2 * Math.PI, el.phasor(662)))),
        ],
        resourceIDs: [],
    };
};
